import React from 'react'
import { industrial_val_data } from '../../data/valuationData';
import { NavLink } from "react-router-dom";

const IndustrialValuationPage = () => {
  return (
    <div className="px-[5vw] sm:px-[10vw] xl:px-[15vw] flex flex-col items-center sm:flex-row pt-[120px] gap-5">
          <div className="h-auto">
            <h1 className="py-2 text-2xl lg:text-3xl font-playfair">
              {industrial_val_data.title}
            </h1>
            <div className="py-5 flex flex-col lg:flex-row justify-center items-center gap-6 lg:gap-20">
              <div className="w-full lg:w-1/2 ">
                <img
                  src={industrial_val_data.image_url}
                  alt=""
                  className="w-full h-auto object-cover"
                />
              </div>
              <div className="w-full lg:w-1/2 space-y-5">
                <p>{industrial_val_data.description}</p>
                <p>{industrial_val_data.para1}</p>
                <p>{industrial_val_data.para2}</p>
    
                <p>
                  Please <NavLink to="/contact-us" className="text-yellow">contact us </NavLink>
                  for a guaranteed competitive quote.
                </p>
              </div>
            </div>
          </div>
        </div>
  )
}

export default IndustrialValuationPage;